import { render } from "./NotFound.vue?vue&type=template&id=db9e207a&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=db9e207a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-db9e207a"

export default script